import Vue from 'vue'
import VueRouter from 'vue-router'

import LoginView from '../views/login'
import ModelListView from '../views/model/list.vue'
import ModelTrainView from '../views/model/train.vue'
import ModelTrainInputView from '../views/model/train/input.vue'
import ModelTrainDataView from '../views/model/train/data.vue'
import ModelTrainOptionView from '../views/model/train/option.vue'
import ModelTrainConfirmView from '../views/model/train/confirm.vue'
import ModelDetailView from '../views/model/detail.vue'
import ModelPredictView from '../views/model/predict.vue'
import ModelPredictResultListView from '../views/model/predict/result-list.vue'
import RentPrefModelPredictView from '../views/model/predict/sx/rent-pref.vue'
import ModelPredictEvaluationsView from '../views/model/predict-evaluation.vue'
import ModelPredictEvaluationsResultListView
  from '../views/model/predict-evaluation/result-list.vue'
import DataCollectView from '../views/data/collect.vue'
import ConvertView from '../views/data/convert.vue'
import ConvertResultListView from '../views/data/convert/result-list.vue'
import AccountView from '../views/account/account.vue'
import InformationView from '../views/information/information.vue'
import CreditView from '../views/credit/credit.vue'
import SupportListView from '../views/support/list.vue'
import SupportDetailView from '../views/support/detail.vue'
import SamplesView from '../views/account/samples.vue'
import ErrorView from '../views/error/error.vue'
import RestrictionsErrorView
  from '../views/restrictions-error/restrictions-error.vue'
import NoContractErrorView
  from '../views/no-contract-error/no-contract-error.vue'

import CommonUtil from '../utils/common'
import WebApiClient from '../api/web'

Vue.config.devtools = true
Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: {
        title: 'ログイン'
      }
    },
    {
      path: '/',
      name: 'model-list',
      component: ModelListView,
      meta: {
        requiresAuth: true,
        title: 'モデル一覧',
        notification: {
          onlyIsNewInfo: false
        }
      }
    }, {
      path: '/model/train',
      name: 'model-train',
      component: ModelTrainView,
      children: [
        {
          path: '',
          name: 'model-train-input',
          component: ModelTrainInputView,
          meta: {
            requiresAuth: true,
            title: 'モデル作成 - 学習データの選択',
            trainType: 'train',
            prev: null,
            next: 'model-train-data',
            notification: {
              onlyIsNewInfo: true
            }
          }
        }, {
          path: 'data',
          name: 'model-train-data',
          component: ModelTrainDataView,
          meta: {
            requiresAuth: true,
            title: 'モデル作成 - 学習データのサマリ',
            trainType: 'train',
            prev: 'model-train-input',
            next: 'model-train-option',
            notification: {
              onlyIsNewInfo: true
            }
          }
        }, {
          path: 'option',
          name: 'model-train-option',
          component: ModelTrainOptionView,
          meta: {
            requiresAuth: true,
            title: 'モデル作成 - 分析のオプション',
            trainType: 'train',
            prev: 'model-train-data',
            next: 'model-train-confirm',
            notification: {
              onlyIsNewInfo: true
            }
          }
        }, {
          path: 'confirm',
          name: 'model-train-confirm',
          component: ModelTrainConfirmView,
          meta: {
            requiresAuth: true,
            title: 'モデル作成 - モデルの作成',
            trainType: 'train',
            prev: 'model-train-option',
            next: null,
            notification: {
              onlyIsNewInfo: true
            }
          }
        }
      ]
    }, {
      path: '/model/update/:modelId',
      name: 'model-update',
      component: ModelTrainView,
      props: true,
      children: [
        {
          path: '',
          name: 'model-update-input',
          component: ModelTrainInputView,
          meta: {
            requiresAuth: true,
            title: 'モデル更新 - 学習データの選択',
            trainType: 'update',
            prev: null,
            next: 'model-update-data',
            notification: {
              onlyIsNewInfo: true
            }
          }
        }, {
          path: 'data',
          name: 'model-update-data',
          component: ModelTrainDataView,
          meta: {
            requiresAuth: true,
            title: 'モデル更新 - 学習データのサマリ',
            trainType: 'update',
            prev: 'model-update-input',
            next: 'model-update-option',
            // next: 'model-update-transform',
            notification: {
              onlyIsNewInfo: true
            }
          }
        }, {
          path: 'option',
          name: 'model-update-option',
          component: ModelTrainOptionView,
          meta: {
            requiresAuth: true,
            title: 'モデル更新 - 分析のオプション',
            trainType: 'update',
            prev: 'model-update-data',
            next: 'model-update-confirm',
            notification: {
              onlyIsNewInfo: true
            }
          }
        }, {
          path: 'confirm',
          name: 'model-update-confirm',
          component: ModelTrainConfirmView,
          meta: {
            requiresAuth: true,
            title: 'モデル更新 - モデルの更新',
            trainType: 'update',
            prev: 'model-update-option',
            next: null,
            notification: {
              onlyIsNewInfo: true
            }
          }
        }
      ]
    }, {
      path: '/model/detail/:modelId',
      name: 'model-detail',
      component: ModelDetailView,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'モデル詳細',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/model/predict/model_rent_pref_kanto',
      name: 'rent-pref-model-predict',
      component: RentPrefModelPredictView,
      props: {
        modelId: 'model_rent_pref_kanto'
      },
      meta: {
        requiresAuth: true,
        title: 'モデル適用',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/model/predict/model_rent_pref_kansai',
      name: 'rent-pref-model-predict',
      component: RentPrefModelPredictView,
      props: {
        modelId: 'model_rent_pref_kansai'
      },
      meta: {
        requiresAuth: true,
        title: 'モデル適用',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/model/predict/:modelId',
      name: 'model-predict',
      component: ModelPredictView,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'モデル適用',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/model/predict/:modelId/results',
      name: 'model-predict-result-list',
      component: ModelPredictResultListView,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'モデル適用結果一覧',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/model/predict-evaluations/:modelId/',
      name: 'model-predict-evaluation',
      component: ModelPredictEvaluationsView,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'モデル適用結果の評価',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/model/predict-evaluations/:modelId/results',
      name: 'model-predict-evaluation-result-list',
      component: ModelPredictEvaluationsResultListView,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'モデル適用結果の評価一覧',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/data/collect',
      name: 'data-collect',
      component: DataCollectView,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'データ収集',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/data/convert',
      name: 'data-convert',
      props: true,
      component: ConvertView,
      meta: {
        requiresAuth: true,
        title: 'データ変換',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/data/convert/results',
      name: 'data-convert-result-list',
      component: ConvertResultListView,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'データ変換結果一覧',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/account',
      name: 'account',
      component: AccountView,
      meta: {
        requiresAuth: true,
        title: 'アカウント情報',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/samples',
      name: 'samples',
      component: SamplesView,
      meta: {
        requiresAuth: true,
        title: 'サンプルデータ',
        notification: {
          onlyIsNewInfo: false
        }
      }
    }, {
      path: '/information',
      name: 'information',
      component: InformationView,
      meta: {
        requiresAuth: true,
        title: 'お知らせ',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/credit',
      name: 'credit',
      component: CreditView,
      meta: {
        requiresAuth: true,
        title: 'クレジット',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/support',
      name: 'support-list',
      component: SupportListView,
      meta: {
        requiresAuth: true,
        title: 'お問合せ一覧',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/support/:supportId',
      name: 'support-detail',
      component: SupportDetailView,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'お問合せ詳細',
        notification: {
          onlyIsNewInfo: true
        }
      }
    }, {
      path: '/error/:code',
      name: 'error',
      component: ErrorView,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'エラー'
      }
    }, {
      path: '/restrictions-error/:code',
      name: 'restrictions-error',
      component: RestrictionsErrorView,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'ご利用制限のお知らせ - SkyFox'
      }
    }, {
      path: '/no-contract-error',
      name: 'no-contract-error',
      component: NoContractErrorView,
      meta: {
        requiresAuth: true,
        title: 'ご利用制限のお知らせ - SkyFox'
      }
    }
  ]
})
router.beforeEach((to, from, next) => {
  const context = router.app
  const $session = context.$session

  if (to.matched.some(record => record.meta.requiresAuth) && !$session.exists()) {
    next({path: '/login', query: {redirect: to.fullPath}})
  } else {
    const toName = CommonUtil.isNotEmpty(to.matched) ? to.matched.slice(
      0)[0].name : ''
    const fromName = CommonUtil.isNotEmpty(from.matched)
      ? from.matched.slice(0)[0].name
      : ''
    if (toName === 'model-train' && fromName !== 'model-train') {
      WebApiClient.checkRestriction(context, next, 'train')
    } else if (toName === 'model-update' && fromName !== 'model-update') {
      WebApiClient.checkRestriction(context, next, 'update')
    } else if (toName === 'model-predict' || toName ===
      'rent-pref-model-predict') {
      WebApiClient.checkRestriction(context, next, 'predict')
    } else if (toName === 'model-predict-evaluation') {
      WebApiClient.checkRestriction(context, next, 'predict-evaluation')
    } else if (toName === 'data-convert') {
      WebApiClient.checkRestriction(context, next, 'convert')
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/extentions/router.js